import axios from "./config";

/**
 * @function
 * @name getSafeguardConcerns
 * @description get safeguards concerns
 * */
const getSafeguardConcerns = () =>
  axios.get(`/safeguard_concerns`).then((response) => response.data.data);

const getProcuringEntitiesStatistics = (id, reportStartDate, reportEndDate) => {
  return axios
    .get(`/procuring_entities/statistics/${id}`, {
      params: {
        report_start_date: reportStartDate,
        report_end_date: reportEndDate,
      },
    })
    .then((response) => response.data)
    .catch((error) => {
      console.error("Failed to fetch data", error);
      throw error;
    });
};
// package_contract_equipments?filter[package_contract_id]=${id}
const getEquipmentsMobilization = (id, reportStartDate, reportEndDate, page = 1, perPage = 15) => {
  return axios
    .get("/package_contract_equipments", {
      params: {
        "filter[package_contract_id]": id,
        report_start_date: reportStartDate,
        report_end_date: reportEndDate,
        page: page,
        per_page: perPage,
      },
    })
    .then((response) => response.data)
    .catch((error) => {
      console.error("Failed to fetch equipment data", error);
      throw error;
    });
};

const getSubProjects = (filterObj) => {
  return axios
    .get(`/sub_projects`, {
      params: {
        ...filterObj,
      },
    })
    .then((response) => response.data)
    .catch((error) => {
      console.error("Failed to fetch sub-project data", error);
      throw error;
    });
};

// package_contract_equipments?filter[package_contract_id]=${id}
const getPackageFinancials = (id) => {
  return axios
    .get(`/package_contract_financials/${id}`)
    .then((response) => response.data)
    .catch((error) => {
      console.error("Failed to fetch equipment data", error);
      throw error;
    });
};

const getPackageContractStaffs = (id, startDate, endDate) => {
  return axios
    .get(`/package-contract-staffs/${id}`, {
      params: {
        start_date: startDate,
        end_date: endDate,
      },
    })
    .then((response) => response.data)
    .catch((error) => {
      console.error("Failed to fetch contract staff data", error);
      throw error;
    });
};

const getPackageEnvironmentalSocialSafeguards = (id, startDate, endDate, page = 1, perPage = 15) => {
  return axios
    .get(`/environmental_social_safeguards/${id}`, {
      params: {
        start_date: startDate,
        end_date: endDate,
        page: page,
        per_page: perPage,
      },
    })
    .then((response) => response.data)
    .catch((error) => {
      console.error("Failed to fetch environmental safeguards data", error);
      throw error;
    });
};
const getMaterialTestingApprovals = (id, startDate, endDate) => {
  return axios
    .get(`/materials_testing_approvals?package_id=${id}`, {
      params: {
        start_date: startDate,
        end_date: endDate,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.error("Failed to fetch material testing approvals data", error);
      throw error;
    });
};

const getConsultantFinancialStatus = (id, startDate, endDate, page = 1, perPage = 15) => {
  return axios
    .get(`/consultant_financial_status?procuring_entity_id=${id}`, {
      params: {
        start_date: startDate,
        end_date: endDate,
        page: page,
        per_page: perPage,
      },
    })
    .then((response) => response.data)
    .catch((error) => {
      console.error("Failed to fetch consultant financial status data", error);
      throw error;
    });
};

const getCscStaffs = (contractId, page = 1, perPage = 15) => {
  return axios
    .get(`/csc_staffs/${contractId}`, {
      params: {
        page: page,
        per_page: perPage,
      },
    })
    .then((response) => response.data)
    .catch((error) => {
      console.error("Failed to fetch CSC staff data", error);
      throw error;
    });
};

const getOutstandRap = (id, startDate, endDate, page = 1, perPage = 10) => {
  return axios
    .get(`/outstanding_raps`, {
      params: {
        procuring_entity_id: id,
        start_date: startDate,
        end_date: endDate,
        page: page,
        per_page: perPage,
      },
    })
    .then((response) => response.data)
    .catch((error) => {
      console.error("Failed to fetch RAP implementation data", error);
      throw error;
    });
};


const getPackageChallenges = (id, startDate, endDate) => {
  const params = {};

  if (startDate) {
    params.start_date = startDate;
  }

  if (endDate) {
    params.end_date = endDate;
  }
  return axios
    .get(`/challenges/${id}`, {
      params: params, // Only include the dates if they are defined
    })
    .then((response) => response.data)
    .catch((error) => {
      console.error("Failed to fetch equipment data", error);
      throw error;
    });
};

const getPctChallenges = (id = null, startDate = null, endDate = null) => {
  const params = {};

  if (startDate) {
    params.start_date = startDate;
  }

  if (endDate) {
    params.end_date = endDate;
  }

  // Build the URL conditionally based on whether id is provided
  const url = id ? `/pct-challenges/${id}` : `/pct-challenges`;

  return axios
    .get(url, {
      params: params, // Only include the dates if they are defined
    })
    .then((response) => response.data)
    .catch((error) => {
      console.error("Failed to fetch PCT challenges data", error);
      throw error;
    });
};

const getPackageContractProgress = (id, startDate, endDate) => {
  // Build params conditionally based on whether the dates are provided
  const params = {};

  if (startDate) {
    params.start_date = startDate;
  }

  if (endDate) {
    params.end_date = endDate;
  }

  return axios
    .get(`/package_contract_progress/${id}`, {
      params: params, // Only include the dates if they are defined
    })
    .then((response) => response.data)
    .catch((error) => {
      console.error("Failed to fetch package contract progress data", error);
      throw error;
    });
};

// const getPackageContractProgress = (id) => {
//   return axios
//     .get(`/package_contract_progress/${id}`)
//     .then((response) => response.data)
//     .catch((error) => {
//       console.error("Failed to fetch equipment data", error);
//       throw error;
//     });
// };

const getPackageProblemsConstrains = (id, startDate, endDate) => {
  return axios
    .get(`/package_problems_and_constraints/${id}`, {
      params: {
        start_date: startDate,
        end_date: endDate,
      },
    })
    .then((response) => response.data)
    .catch((error) => {
      console.error("Failed to fetch problems and constraints data", error);
      throw error;
    });
};

const getPackageGrievances = (id, startDate, endDate, page = 1, perPage = 10) => {
  return axios
    .get(`/procuring_entity_package_grievances/${id}`, {
      params: {
        start_date: startDate,
        end_date: endDate,
        page: page,
        per_page: perPage,
      },
    })
    .then((response) => response.data)
    .catch((error) => {
      console.error("Failed to fetch grievances data", error);
      throw error;
    });
};
const getPackageIncidents = (id, startDate, endDate, page = 1, perPage = 10) => {
  return axios
    .get(`/incidents_and_accidents/${id}`, {
      params: {
        report_start_date: startDate,
        report_end_date: endDate,
        page: page,
        per_page: perPage,
      },
    })
    .then((response) => response.data)
    .catch((error) => {
      console.error("Failed to fetch incidents data", error);
      throw error;
    });
};
const getPackageRelocationUtilities = (id, startDate, endDate, page = 1, perPage = 10) => {
  return axios
    .get(`/package_relocated_utilities/${id}`, {
      params: {
        start_date: startDate,
        end_date: endDate,
        page: page,
        per_page: perPage,
      },
    })
    .then((response) => response.data)
    .catch((error) => {
      console.error("Failed to fetch relocation utilities data", error);
      throw error;
    });
};

const getPackageFinancialStatus = (id, startDate, endDate, page = 1, perPage = 10) => {
  return axios
    .get(`/financial_statuses/${id}`, {
      params: {
        start_date: startDate,
        end_date: endDate,
        page: page,
        per_page: perPage,
      },
    })
    .then((response) => response.data)
    .catch((error) => {
      console.error("Failed to fetch financial status data", error);
      throw error;
    });
};

const exportPackageFinancialStatus = (id, startDate, endDate) => {
  return axios
    .get(`/financial_statuses/${id}/export`, {
      params: {
        start_date: startDate,
        end_date: endDate,
      },
      responseType: "blob", // Important for file downloads
    })
    .then((response) => {
      // Create blob link to download
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;

      // Extract filename from response headers or use default
      const contentDisposition = response.headers["content-disposition"];
      let filename = "financial_status_export.csv";
      if (contentDisposition) {
        const filenameMatch = contentDisposition.match(/filename="(.+)"/);
        if (filenameMatch) {
          filename = filenameMatch[1];
        }
      }

      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

      return response;
    })
    .catch((error) => {
      console.error("Failed to export financial status data", error);
      throw error;
    });
};

/**
 * @function
 * @name exportFinancialStatus
 * @description Export financial status report with date range filtering
 * @param {string} startDate - Start date in YYYY-MM-DD format
 * @param {string} endDate - End date in YYYY-MM-DD format
 */
const exportFinancialStatus = (startDate = null, endDate = null) => {
  const params = {};
  
  if (startDate) {
    params.start_date = startDate;
  }
  
  if (endDate) {
    params.end_date = endDate;
  }
  
  return axios
    .get(`/financial_statuses/export`, {
      params,
    })
    .then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;

      const contentDisposition = response.headers["content-disposition"];
      let filename = "financial_status_export.csv";
      if (contentDisposition) {
        const filenameMatch = contentDisposition.match(/filename="(.+)"/);
        if (filenameMatch) {
          filename = filenameMatch[1];
        }
      }

      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

      return response;
    })
    .catch((error) => {
      console.error("Failed to export financial status data", error);
      throw error;
    });
};

const getPackageProjects = () => {
  return axios
    .get(`/projects/`)
    .then((response) => response.data)
    .catch((error) => {
      console.error("Failed to fetch equipment data", error);
      throw error;
    });
};

const getSafeguardConcernsStatistics = (id) =>
  axios
    .get(`/procuring_entities/${id}/safeguard_concerns/statistics`)
    .then((response) => response.data);
export default {
  getSafeguardConcerns,
  getProcuringEntitiesStatistics,
  getSafeguardConcernsStatistics,
  getEquipmentsMobilization,
  getPackageFinancials,
  getPackageContractStaffs,
  getPackageChallenges,
  getPctChallenges,
  getPackageContractProgress,
  getPackageProblemsConstrains,
  getPackageGrievances,
  getPackageRelocationUtilities,
  getPackageIncidents,
  getPackageFinancialStatus,
  getPackageEnvironmentalSocialSafeguards,
  getMaterialTestingApprovals,
  getSubProjects,
  getConsultantFinancialStatus,
  getCscStaffs,
  getOutstandRap,
  getPackageProjects,
  exportPackageFinancialStatus,
  exportFinancialStatus,
};
